import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonProps } from "./Button.types";

/** The page builder's button, drawn as the legacy one is. */
export function Button({
  text,
  title,
  icon,
  iconClassName,
  variant = "info",
  className,
  disabled = false,
  showSpinner = false,
  isBlock = false,
  type = "button",
  onClick,
}: ButtonProps) {
  return (
    <button
      aria-label={title && !text ? title : undefined}
      onClick={onClick}
      title={title}
      type={type}
      className={classNames(
        "btn position-relative",
        variant !== "none" && `btn-${variant}`,
        isBlock && "w-100",
        className
      )}
      disabled={disabled}
    >
      {showSpinner && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
        </div>
      )}
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={classNames(
            Boolean(text) && "me-3",
            showSpinner && "opacity-25",
            iconClassName
          )}
        />
      )}
      <span className={showSpinner ? "opacity-25" : ""}>{text}</span>
    </button>
  );
}

export default Button;
